import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { DefaultErrorMessage } from "shared/constants/message";
import { getDistrictListApi, getProvinceListApi, getWardListApi } from "states/address/address.api";
import { DistrictModel, ProvinceModel, WardModel } from "states/address/address.models";
import { getCustomerAddressApi } from "states/customer-address/customer-address.api";
import { CustomerAddressModel } from "states/customer-address/customer-address.models";
import { globalValueSetToast } from "states/global-value/global-value.action";
import { ToastModel, ToastType } from "states/global-value/global-value.models";
import "./address-form.less";
interface AddressFormProps {
  isModal: boolean;
  isUpdate: boolean;
  addressId: string | number;
  onModal: (isModal: boolean) => void;
  onUpdate: (address: CustomerAddressModel) => void;
  onAdd: (address: CustomerAddressModel) => void;
}
export const AddressFormComponent = (props: AddressFormProps) => {
  const {
    isModal,
    addressId,
    isUpdate,
    onModal,
    onUpdate,
    onAdd,
  } = props;
  const dispatch = useDispatch();
  const [provinces, setProvinces] = useState<ProvinceModel[]>([]);
  const [districts, setDistricts] = useState<DistrictModel[]>([]);
  const [wards, setWards] = useState<WardModel[]>([]);
  const [customerAddress,setCustomerAddress] = useState<CustomerAddressModel>({} as CustomerAddressModel);
  const _handleGetAddress = async () => {
    try {
      let result = await getCustomerAddressApi(addressId);
      setCustomerAddress(result.data);
      _handleGetDistricts(result.data.provinceId);
      _handleGetWards(result.data.districtId);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleGetProvince = async () => {
    try {
      let result = await getProvinceListApi();
      setProvinces(result.data);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleGetDistricts = async (id: string | number) => {
    try {
      let result = await getDistrictListApi(id);
      setDistricts(result.data);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleGetWards = async (id: string | number) => {
    try {
      let result = await getWardListApi(id);
      setWards(result.data);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  useEffect(() => {
    if (isUpdate) {
      _handleGetAddress();
    }else{
      setCustomerAddress({} as CustomerAddressModel);
      setDistricts([]);
      setWards([]);
    }
    _handleGetProvince();
  }, [isUpdate,addressId]);
  return (
    customerAddress ? (
      <CSSTransition
        in={isModal}
        timeout={500}
        classNames="slide"
        mountOnEnter={isModal}
        unmountOnExit={!isModal}
      >
         <div className={`address-form-container ${isModal ? `active`: ``}`}>
        <div className="address-form-container-inner">
          <div className="row-container">
            <label>
              Họ và tên <span className="required">*</span>
            </label>
            <input
              type="text"
              value={customerAddress?.name ?? ""}
              placeholder="Họ và tên"
              onChange={(ev) => {
                setCustomerAddress({...customerAddress,name:ev.target.value})
              }}
              className="form-control"
            />
          </div>
          <div className="row-container">
            <label>
              Số điện thoại <span className="required">*</span>
            </label>
            <input
              type="text"
              value={customerAddress?.phoneNumber ?? ""}
              placeholder="Số điện thoại"
              onChange={(ev) => {
                setCustomerAddress({...customerAddress, phoneNumber:ev.target.value})
              }}
              className="form-control"
            />
          </div>
          <div className="row-container">
            <label>
            Tỉnh / thành phố <span className="required">*</span>
            </label>
            <select
              value={customerAddress?.provinceId ?? ""}
              onChange={(ev) => {
                if (ev.target.value === null || ev.target.value === "") {
                  setDistricts([]);
                  setWards([]);
                  return false;
                }
                setCustomerAddress({
                  ...customerAddress,
                  provinceId: Number(ev.target.value),
                  districtId: 0,
                  wardId: 0
                });
                _handleGetDistricts(ev.target.value);
              }}          
              className="form-control"
            >
               <option value="">Chọn tỉnh / thành phố</option>
              {provinces &&
                provinces.map((province) => (
                  <option key={province.id} value={province.id}>
                    {province.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="row-container">
            <label>
            Quận / huyện <span className="required">*</span>
            </label>
            <select
            value={customerAddress?.districtId ?? ""}
              onChange={(ev) => {
                if (ev.target.value === null || ev.target.value === "") {
                  setWards([]);
                  return false;
                }
                setCustomerAddress({
                  ...customerAddress,
                  districtId: Number(ev.target.value),
                });
                _handleGetWards(ev.target.value);
              }}
              className="form-control"
            >
              <option value="">Chọn Quận / huyện</option>
              {districts &&
                districts.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="row-container">
            <label>
            Phường / xã <span className="required">*</span>
            </label>
            <select
            value={customerAddress?.wardId ?? ""}
            onChange={(ev) => {
              if (ev.target.value === null || ev.target.value === "") {
                return false;
              }
              setCustomerAddress({
                ...customerAddress,
                wardId: Number(ev.target.value),
              });
            }}
            className="form-control"
          >
            <option value="">Chọn phường / xã</option>
            {wards &&
              wards.map((ward) => (
                <option key={ward.id} value={ward.id}>
                  {ward.name}
                </option>
              ))}
          </select>
          </div>
          <div className="row-container">
            <label>
              Địa chỉ <span className="required">*</span>
            </label>
            <input
              type="text"
              value={customerAddress?.address ?? ""}
              placeholder="Địa chỉ"
              onChange={(ev) => {
                setCustomerAddress({...customerAddress,address:ev.target.value})
              }}
              className="form-control"
            />
          </div>
          <div className="row-container">
            <div className="btn-container">
              <button
                onClick={(ev) => {
                  ev.preventDefault();
                  onModal(false);
                }}
                className="btn btn-default"
              >
                Hủy
              </button>
              <button
                onClick={(ev) => {
                  ev.preventDefault();  
                  if(isUpdate){
                    onUpdate(customerAddress);
                  }else{
                    onAdd(customerAddress)
                  }
                }}
                className="btn btn-primary"
              >
               Cập nhật
              </button>
            </div>
          </div>
        </div>
      </div>
      </CSSTransition>
    ): null
  );
};
